import React, { useContext, useEffect, useState } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext'
import Popup from '../Common/Popup'

/**
 * The YearFoundedFilter function is a React component that displays a filter for selecting the start
 * and end years of a company's founding.
 * @returns The YearFoundedFilter component is returning a JSX element.
 */
function YearFoundedFilter({
    EndYearOptions,
    setEndYearOptions,
    StartYearOptions,
    setStartYearOptions,
    customPathname,
    label = "Year Founded",
    isPopupOpen,
    setIsPopupOpen
}) {

    const { YearFounded, refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const start = refineSearchFilters[customPathname]?.yearFounded?.at(0) ?? null;
        const end = refineSearchFilters[customPathname]?.yearFounded?.at(1) ?? null;
        setStartYearOptions(YearFounded?.map(year => ({ ...year, isChecked: start?.name == year.name })))
        setEndYearOptions(YearFounded?.map(year => ({ ...year, isChecked: end?.name == year.name })))
    }, [YearFounded, customPathname, refineSearchFilters, setEndYearOptions, setStartYearOptions])

    const selectedEndYear = EndYearOptions?.filter(option => option.isChecked)?.at(0)
    const selectedStartYear = StartYearOptions?.filter(option => option.isChecked)?.at(0)

    // Start Founded year
    const handleStartYearFoundedChange = (e) => {
        setStartYearOptions(StartYearOptions?.map(option => ({ ...option, isChecked: e.target.value == option.name })))
    }

    // End Founded year 
    const handleEndYearFoundedChange = (e) => {
        if (parseInt(e.target.value) < parseInt(selectedStartYear?.name ?? 0)) {
            alert('Year Before is not lesser than year After')
        } else {
            setEndYearOptions(EndYearOptions?.map(option => ({ ...option, isChecked: e.target.value == option.name })))
        }
    }

    const getDisplayText = () => {
        if (selectedStartYear && selectedEndYear) {
            return `${selectedStartYear.name} to ${selectedEndYear.name}`;
        } else if (selectedStartYear) {
            return `From ${selectedStartYear.name}`;
        } else if (selectedEndYear) {
            return `Up to ${selectedEndYear.name}`;
        }
        return "Select range";
    };

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label}</span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {(selectedStartYear || selectedEndYear) && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {getDisplayText()}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        <div className="mb-3">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                From Year
                            </label>
                            <select 
                                value={selectedStartYear?.name ?? ""} 
                                onChange={handleStartYearFoundedChange}
                                className="w-full p-2 border border-[#D9BD7F] rounded focus:outline-none bg-white"
                            >
                                <option value="">Select start year</option>
                                {StartYearOptions && StartYearOptions.length > 0 ? (
                                    StartYearOptions.slice(0).reverse().map((year, index) => (
                                        <option key={index} value={year.name ? year.name : ''}>
                                            {year.name ? year.name : ''}
                                        </option>
                                    ))
                                ) : (
                                    <option disabled>No results found!</option>
                                )}
                            </select>
                        </div>
                        
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                To Year
                            </label>
                            <select 
                                value={selectedEndYear?.name ?? ""} 
                                onChange={handleEndYearFoundedChange}
                                className="w-full p-2 border border-[#D9BD7F] rounded focus:outline-none bg-white"
                            >
                                <option value="">Select end year</option>
                                {EndYearOptions && EndYearOptions.length > 0 ? (
                                    EndYearOptions.slice(0).reverse().map((year, index) => (
                                        <option key={index} value={year.name ? year.name : ''}>
                                            {year.name ? year.name : ''}
                                        </option>
                                    ))
                                ) : (
                                    <option disabled>No results found!</option>
                                )}
                            </select>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    )
}

export default YearFoundedFilter